import { render, staticRenderFns } from "./PerfumeItem.vue?vue&type=template&id=32f37290&scoped=true&"
import script from "./PerfumeItem.vue?vue&type=script&lang=js&"
export * from "./PerfumeItem.vue?vue&type=script&lang=js&"
import style0 from "./PerfumeItem.vue?vue&type=style&index=0&id=32f37290&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f37290",
  null
  
)

export default component.exports